import { compose } from 'redux'
import { connect } from 'react-redux'
import { withFormik } from 'formik'
import { bindPromiseCreators } from '../../utils/routines'
import * as yup from 'yup'
import '../../utils/validations/extendYup'

import { createRecoverPasswordPromise } from './routines'
import { withRecoverPasswordSaga } from './saga'
import RecoverPasswordForm from './Forms/RecoverPasswordForm'

// connector
const mapDispatchToProps = bindPromiseCreators({
  recoverPassword: createRecoverPasswordPromise
})

const connector = connect(null, mapDispatchToProps)

// formik
const mapPropsToValues = () => ({
  username: ''
})
const validationSchema = yup.object().shape({
  username: yup.string()
    .email()
    .required()
})
async function handleSubmit(values, {
  setStatus,
  setSubmitting,
  props
}) {
  try {
    await props.recoverPassword(values)
    setStatus({ success: true })
  } catch (error) {
    setStatus({ error })
  } finally {
    setSubmitting(false)
  }
}

const formik = withFormik({
  mapPropsToValues,
  validationSchema,
  handleSubmit
})

export default compose(
  withRecoverPasswordSaga,
  connector,
  formik
)(RecoverPasswordForm)
